<a nz-dropdown
           [nzDropdownMenu]="menu"
           nzTrigger="click"
           nzPlacement="bottomRight"
           [(nzVisible)]="open"
           class="bell-trigger"
           aria-label="{{'notifications.title'|translateTA}}">
            <nz-badge [nzCount]="unreadCount()" [nzOverflowCount]="10" nzSize="small">
                <span nz-icon nzType="bell" nzTheme="outline" class="bell-icon"></span>
            </nz-badge>
        </a>
 
        <nz-dropdown-menu #menu="nzDropdownMenu">
            <div class="notif-panel">
                <div class="notif-header">
                    <span class="notif-title-h">{{'notifications.title'|translateTA}}</span>
                    <a *ngIf="unreadCount() > 0"
                       class="mark-all"
                       (click)="markAllAsRead(); $event.stopPropagation()">
                        {{'notifications.markAllRead'|translateTA}}
                    </a>
                </div>
 
                <div class="notif-list" *ngIf="items().length; else emptyTpl">
                    <div *ngFor="let n of visibleItems; trackBy: trackById"
                         class="notif-item"
                         [class.unread]="n.STATUS?.toLowerCase()=='new'"
                         (click)="navigate($event, n)">
                        <span nz-icon
                              [nzType]="iconFor(n.STATUSALERT)"
                              nzTheme="outline"
                              class="notif-icon"
                              [ngClass]="n.STATUSALERT || 'info'"></span>
 
                        <div class="notif-body">
                            <div class="notif-line1" [class.islink]="n.ROUTE!= null" (click)="navigate($event, n)">{{ n.SUBJECT }}</div>
                            <div class="notif-msg">{{ n.MESSAGE }}</div>
                            <div class="notif-time">{{ n.RECCREATEDON |  date:'dd/MM/yyyy HH:mm:ss' }}</div>
                        </div>
 
                        <span class="unread-dot" *ngIf="n.STATUS.toLowerCase()=='new'" title="{{'notifications.notRead'|translateTA}}"></span>
                    </div>
                </div>
 
                <ng-template #emptyTpl>
                    <nz-empty class="notif-empty"
                              nzNotFoundContent="{{'notifications.noNotifications'|translateTA}}"></nz-empty>
                </ng-template>
 
                <div class="notif-footer" *ngIf="items().length > 5">
                     <a (click)="toggleSeeAll()">
                        {{ showAll ? ('notifications.seeLess'|translateTA) : ('notifications.seeAll'|translateTA) }}
                    </a>
                </div>
            </div>
        </nz-dropdown-menu>